import { path } from 'd3-path'
import pointer from './helpers/pointer.js'
import Symbol2d from '../2d.js'
import tipLock from './helpers/tip-lock.js'

export default class QuadArrow extends Symbol2d {

  static mixins = [tipLock]

  handles = [{
    defaults: [.85, .4],
    constraints: (dimensions, handles) => {
      const yMax = .49
      const y = Math.min(yMax, handles[0].coords[1])

      // Make sure the handle doesn't allow the vertical arrows to extend beyond the width
      const yc1 = (dimensions.center[1] - dimensions.width * .25) / dimensions.height
      const yc2 = .25 // the y value can't go above 25% b/c the arrow will be too tall and extend the height
      const yConstraint = [Math.max(yc1, yc2), yMax]

      // Determine x constraints
      const tip = Math.max(dimensions.center[1] - dimensions.height * y, 0)
      let maxArrowHeight = dimensions.center[1] - tip * 2

      const xc1 = (dimensions.width - maxArrowHeight) / dimensions.width
      const xc2 = (dimensions.center[0] + tip * 2) / dimensions.width
      const xConstraint = [Math.max(xc1, xc2), 1]

      return [xConstraint, yConstraint]
    },
    cursor: 'all-scroll'
  }]

  path (dimensions, handles) {
    const _path = path()
    // We can't use the this._pointer created by the tipLock `getComponents` mixin,
    // b/c it extends the full height of the container. The quad-arrow pointer height
    // doesn't extend the full height of the container.
    const _pointer = pointer(_path, dimensions, handles[0])
    const halfBase = _pointer.width / 2
    const start = [dimensions.center[0] - halfBase, dimensions.center[1] - halfBase]

    _path.moveTo(...start)
    _pointer(start, 'north')
    _pointer([dimensions.center[0] + halfBase, dimensions.center[1] - halfBase], 'east')
    _pointer([dimensions.center[0] + halfBase, dimensions.center[1] + halfBase], 'south')
    _pointer([dimensions.center[0] - halfBase, dimensions.center[1] + halfBase], 'west')
    _path.closePath()

    return _path.toString()
  }

  textContainer (dimensions, handles) {
    // Find the x coordinate where the top base of the pointer intersects arrow diagonal line
    const pt1 = [dimensions.width - this._pointer.height, dimensions.center[1] - this._pointer.width]
    const pt2 = [dimensions.width, dimensions.center[1]]
    const y = dimensions.height * handles[0][1]

    // Calculate slope (m)
    const m = (pt2[1] - pt1[1]) / (pt2[0] - pt1[0])
    // Calculate y-intercept (b)
    const b = pt1[1] - m * pt1[0]
    // Calculate x for a given y
    const x = (y - b) / m

    const width = (x - dimensions.center[0]) * 2

    return {
      center: dimensions.center,
      width,
      height: this._pointer.width,
    }
  }

}
